// 批次号列表

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import copy from "copy-to-clipboard";
import "./CommandIssued.scss";
import { DownloadOutlined } from "@ant-design/icons";
import { Table, Space, message, Tooltip, ConfigProvider, Button } from "antd";
import zh_CN from "antd/es/locale/zh_CN";
import { exportExcel } from "../../../utils/index";
import BoxServe from "../../../ajax/api/index";
import SearchHead from "./components/SearchHead"; // 搜索区域
// 已发命令列表
export default function CommandIssued(props) {
  // 提示信息
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const columns = [
    {
      title: "批次号",
      key: "batchNo",
      dataIndex: "batchNo",
      width: 300,
    },
    {
      title: "命令",
      key: "command",
      dataIndex: "command",
      textWrap: "word-break",
      with: 120,
      render: (_, record) => (
        <Space size="middle">
          <div className="result-content">
            <span className="text-content" style={{ maxWidth: "100px" }}>
              <Tooltip
                overlayStyle={{ maxWidth: "90%" }}
                title={record?.command}
                color={"blue"}
                key={"blue"}
              >
                <span>{record?.command}</span>
              </Tooltip>
            </span>
            <span
              className="text-copy"
              style={{ maxWidth: "100px" }}
              onClick={(e) => handleCopy(record.command)}
            >
              {record?.command !== "" && String(record?.command) !== "null"
                ? "复制"
                : ""}
            </span>
          </div>
        </Space>
      ),
    },
    {
      title: "入库状态",
      key: "rukuState",
      dataIndex: "rukuState",
      with: 80,
    },
    {
      title: "命令总数量",
      key: "totalNum",
      dataIndex: "totalNum",
      with: 100,
      render: (_, record) => (
        <Space size="middle">
          <span style={{ color: "magenta", fontWeight: "bold" }}>
            {record.totalNum}
          </span>
        </Space>
      ),
    },
    {
      title: "命令已执行数量",
      key: "runNum",
      dataIndex: "runNum",
      with: 180,
      render: (_, record) => (
        <Space size="middle">
          <span style={{ color: "#f50", fontWeight: "bold" }}>
            {record.runNum}
          </span>
        </Space>
      ),
    },
    {
      title: "命令执行成功数量",
      key: "sucessNum",
      dataIndex: "sucessNum",
      with: 180,
      render: (_, record) => (
        <Space size="middle">
          <span style={{ color: "#108ee9", fontWeight: "bold" }}>
            {record.sucessNum}
          </span>
        </Space>
      ),
    },
    {
      title: "是否长期命令",
      key: "longCmd",
      dataIndex: "longCmd",
      with: 180,
      render: (_, record) => (
        <Space size="middle">
          <span>{record.longCmd === 1 ? "是" : "否"}</span>
        </Space>
      ),
    },
    {
      title: "备注",
      key: "remark",
      dataIndex: "remark",
      with: 300,
      render: (_, record) => (
        <Space size="middle">
          <div className="result-content">
            <span className="text-content">
              <Tooltip
                overlayStyle={{ maxWidth: "90%" }}
                title={record?.remark}
                color={"blue"}
                key={"blue"}
              >
                <span>{record?.remark}</span>
              </Tooltip>
            </span>
            <span
              className="text-copy"
              onClick={(e) => handleCopy(record.remark)}
            >
              {record?.remark !== "" && String(record?.remark) !== "null"
                ? "复制"
                : ""}
            </span>
          </div>
        </Space>
      ),
    },
    {
      title: "操作时间",
      key: "createTime",
      dataIndex: "createTime",
      with: 180,
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      fixed: "right",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <span className="action-btn" onClick={() => handleSee(record)}>
            查看
          </span>
        </Space>
      ),
    },
  ];

  const [tableParams, setTableParams] = useState({
    page: 1,
    limit: 20,
    current: 1,
    defaultPageSize: 20,
  });

  const [pagination, setPagination] = useState({
    page: tableParams.current,
    limit: 20,
  });

  // 搜索条件
  const [searchParams, setSearchParams] = useState({});

  // 勾选选择
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // 勾选选择的deviceNo集合
  const [deviceNoList, setDeviceNoList] = useState([]);

  const [loading, setLoading] = useState(false);

  let [list, setList] = useState([]);
  // 总条数
  const [total, setTotal] = useState(0);

  // 搜索
  const handleSearch = (obj) => {
    setSearchParams(obj);
    setPagination({
      page: 1,
      limit: 20,
    });
    setTableParams({
      page: 1,
      current: 1,
    });
  };

  // 勾选选择
  const onSelectChange = (newSelectedRowKeys, filters) => {
    const list = filters?.map((item) => item.deviceNo);
    setDeviceNoList(list);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  // 勾选选择
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  // 查看
  const handleSee = (record) => {
    navigate("/device/BatchList", {
      state: {
        ...record,
      },
    });
  };

  // 分页等
  const onChange = (pagination) => {
    const { current, pageSize } = pagination;
    setList([]);
    setPagination({
      page: current,
      limit: pageSize,
    });
    setTableParams({
      page: current,
      current: current,
    });
  };

  const handleCopy = (contents) => {
    if (copy(contents)) {
      messageApi.open({
        type: "success",
        content: "复制成功！",
      });
    } else {
      messageApi.open({
        type: "error",
        content: "复制失败！",
      });
    }
  };

  // 获取列表数据
  const getPageBatchList = async () => {
    try {
      setLoading(true);
      const { code, data, count } = await BoxServe.getPageBatchList({
        ...searchParams,
        ...pagination,
      }).finally(() => {
        setLoading(false);
      });
      if (String(code) === "0") {
        setTableParams({
          ...tableParams,
          total: count ? Number(count) : 0,
        });
        setTotal(count ? Number(count) : 0);
        const list = data?.map((item) => {
          return {
            ...item,
            key: item?.batchNo,
          };
        });
        setList(list);
      } else {
        messageApi.open({
          type: "warning",
          content: "出错了~",
        });
      }
    } catch (error) {
      // message.error(error.message || error.msg)
      console.log(error);
    }
  };

  useEffect(() => {
    getPageBatchList();
  }, [props, searchParams, pagination]);

  const handleExportExcel = () => {
    const name = `box_已发命令列表_${new Date().getTime()}`;
    const sheetHeader = [];
    const sheetFilter = [];
    const columnWidths = [];

    // const sheetHeader = ["设备号", "状态", "设备所在地", "运行业务"];
    // let sheetFilter = ["deviceNo", "onlineState", "city", "askBusiness"];
    columns?.forEach((item) => {
      let { title, dataIndex, width } = item;
      if (title !== "操作") {
        sheetHeader.push(title);
      }
      sheetFilter.push(dataIndex);
      columnWidths.push(width / 10);
    });
    exportExcel(list, name, sheetHeader, sheetFilter, columnWidths);
  };

  // 重置
  const handleReset = () => {
    setTableParams({
      page: 1,
      limit: 20,
      current: 1,
      defaultPageSize: 20,
    });
    setPagination({
      page: 1,
      // current: 1,
      limit: 20,
    });
  };

  return (
    <>
      {contextHolder}
      <div className="command-issued">
        <div className="search-wrap">
          <SearchHead handleSearch={handleSearch} handleReset={handleReset} />
        </div>
        <div className="top">
          <div className="top-left"></div>
          <div className="top-right">
            <Space wrap className="operate-btn">
              <Button
                type="dashed"
                danger
                icon={<DownloadOutlined />}
                onClick={handleExportExcel}
              >
                导出Excel
              </Button>
            </Space>
          </div>
        </div>
        <ConfigProvider locale={zh_CN}>
          <Table
            scroll={{
              x: 1740,
            }}
            filterMultiple
            columns={columns}
            dataSource={list}
            loading={loading}
            pagination={{
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50, 100, 500, 1000, 5000, 10000],
              total,
              ...tableParams,
              showTotal: (total) => {
                return `共 ${total} 条`;
              },
            }}
            onChange={onChange}
          />
        </ConfigProvider>
      </div>
    </>
  );
}
